<div class="page gray-font-color font-family">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()" data-testid="dqf-list-back">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div class="header-text" data-testid="dqf-list-header">Carrier Associations</div>
  </div>
  <div class="content">
    <div class="dqf-list-container">
      @if (isContentReady && carrierAssociationCards?.length === 0) {
        <div  class="description-banner" data-testid="dqf-list-empty">
          <div class="description">
            <span>No carrier associations to show </span>
          </div>
        </div>
      }
      @if (!isContentReady) {
        <app-skeleton-dqf-list></app-skeleton-dqf-list>
      }
      @if (isContentReady) {
        <div class="dqf-list">
          @for (carrier of carrierAssociationCards; track carrier.carrierCompanyId; let i = $index) {
            <div
              class="dqf-item-container"
              [ngClass]="{'disabled': isWithdrawn(carrier.dqfStatus)}"
              (click)="!isWithdrawn(carrier.dqfStatus) && onCarrierCardClick(carrier)"
              [attr.data-id]="carrier.carrierCompanyName"
              [attr.data-testid]="'dqf-list-card-' + (carrier.carrierCompanyName | lowercase)"
              >
              <div class="company-card-content">
                <div class="company-avatar">
                  <img [src]="carrier.carrierCompanyLogo" class="company-image" />
                </div>
                <div class="company-info">
                  <div class="company-name" [attr.data-testid]="'dqf-list-name-' + (carrier.carrierCompanyName | lowercase)">{{ carrier.carrierCompanyName }}</div>
                  <div class="company-date">{{ carrier.createdAt | date: 'MMM dd, yyyy' }}</div>
                </div>
                <div class="status-area">
                  <!-- For Hired Drivers - Always show Active -->
                  @if (isHired(carrier.hiredStatus)) {
                    <div class="status-badge status-active" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                      <span class="status-dot"></span>
                      Active
                    </div>
                  }
                  <!-- For Non-Hired Drivers with DQF -->
                  @if (!isHired(carrier.hiredStatus) && carrier.hasDqf) {
                    @if (isInComplete(carrier.dqfStatus)) {
                      <div class="status-badge status-incomplete" data-test="dqf-incomplete-button" [attr.data-testid]="'dqf-submit-' + (carrier.carrierCompanyName | lowercase)">
                        Submit DQF
                      </div>
                    }
                    @if (isPending(carrier.dqfStatus)) {
                      <div class="status-badge status-pending" data-test="dqf-under-review-button" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                        Under Review
                      </div>
                    }
                    @if (isRejected(carrier.dqfStatus)) {
                      <div class="status-badge status-rejected" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                        Rejected
                      </div>
                    }
                    @if (isApproved(carrier.dqfStatus)) {
                      <div class="status-badge status-approved" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                        <mat-icon class="status-icon">check_circle</mat-icon>
                        Approved
                      </div>
                    }
                    @if (isWithdrawn(carrier.dqfStatus)) {
                      <div class="status-badge status-withdrawn" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                        <mat-icon class="status-icon">block</mat-icon>
                        Withdrawn
                      </div>
                    }
                  }
                  <!-- For Non-Hired Drivers without DQF (Pending Onboarding) -->
                  @if (!isHired(carrier.hiredStatus) && !carrier.hasDqf) {
                    <div class="status-badge status-pending-onboarding" [attr.data-testid]="'dqf-status-' + (carrier.carrierCompanyName | lowercase)">
                      Pending
                    </div>
                  }
                </div>
              </div>
              @if (carrier.driverVisibleContacts?.length) {
                <div class="card-contacts-section" (click)="$event.stopPropagation()">
                  <button
                    type="button"
                    class="contacts-icon-btn"
                    (click)="toggleCardContactsExpanded($event, carrier)"
                    [attr.aria-expanded]="carrier.contactsExpanded"
                    [attr.data-testid]="'dqf-contacts-' + (carrier.carrierCompanyName | lowercase)"
                    aria-label="Company contacts, tap to expand or collapse">
                    <mat-icon svgIcon="personnel-icon" class="contacts-trigger-icon"></mat-icon>
                  </button>

                  @if (carrier.contactsExpanded) {
                    <div class="card-contacts-body">
                      @for (contact of carrier.driverVisibleContacts; track $index) {
                        <article class="card-contact-card">
                          <h3 class="card-contact-card-title">{{ contactTypeLabel(contact.type) }}</h3>
                          <div class="card-contact-card-details">
                            @if (contact.phoneNumber) {
                              <div class="card-contact-line">
                                <mat-icon svgIcon="phonecall" class="card-contact-icon" aria-hidden="true"></mat-icon>
                                <div class="card-contact-text">
                                  <span class="card-contact-label">Phone Number</span>
                                  <a class="card-contact-value" [href]="'tel:' + contact.phoneNumber" (click)="$event.stopPropagation()">{{ contact.phoneNumber }}</a>
                                </div>
                              </div>
                            }
                            @if (contact.whatsApp) {
                              <div class="card-contact-line">
                                <mat-icon svgIcon="customer-whatsapp" class="card-contact-icon" aria-hidden="true"></mat-icon>
                                <div class="card-contact-text">
                                  <span class="card-contact-label">WhatsApp</span>
                                  @if (whatsappHref(contact.whatsApp)) {
                                    <a class="card-contact-value" [href]="whatsappHref(contact.whatsApp)" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">{{ contact.whatsApp }}</a>
                                  } @else {
                                    <span class="card-contact-value card-contact-value--muted">{{ contact.whatsApp }}</span>
                                  }
                                </div>
                              </div>
                            }
                            @if (contact.email) {
                              <div class="card-contact-line">
                                <mat-icon svgIcon="email" class="card-contact-icon" aria-hidden="true"></mat-icon>
                                <div class="card-contact-text">
                                  <span class="card-contact-label">Email</span>
                                  <a class="card-contact-value" [href]="'mailto:' + contact.email" (click)="$event.stopPropagation()">{{ contact.email }}</a>
                                </div>
                              </div>
                            }
                            @if (contact.hoursAvailable) {
                              <div class="card-contact-line">
                                <mat-icon svgIcon="on-duty-icon" class="card-contact-icon" aria-hidden="true"></mat-icon>
                                <div class="card-contact-text">
                                  <span class="card-contact-label">Hours Available</span>
                                  <span class="card-contact-value card-contact-value--muted">{{ contact.hoursAvailable }}</span>
                                </div>
                              </div>
                            }
                          </div>
                        </article>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
